<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <!-- HEADER -->
  <mat-toolbar class="header">
    <div>
      <img *ngIf="logo" class="toolbar__logo" alt="logo" [src]="logo" />
    </div>
    <div class="toolbar_selector">
      <app-language-selector class="toolbar__button__language" icon="true"></app-language-selector>
    </div>
  </mat-toolbar>
  <!-- BODY -->
  <div class="wrapper wrapper--noauth" fxLayoutAlign="center center" fxFlex="100%">
    <div fxFlex="100" class="wrapper__content">
      <mat-card fxFlex="100">
        <scf-logalty-signature *ngIf="responseOK" [hasReturn]="false"></scf-logalty-signature>
      </mat-card>
    </div>
  </div>
  <!-- FOOTER -->
  <mat-toolbar class="footer">
    <p>{{ name }}</p>
  </mat-toolbar>
</div>
